import React from 'react'
import { useTranslate, required, Form } from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Button,
  DialogActions,
  Chip,
  Avatar,
  Paper,
  Typography,
  Skeleton,
} from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import LoadingButton from '@mui/lab/LoadingButton'
import { useCardId } from 'src/components/pages/sales/reservation/context/CardIdContext'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { tagServices } from 'src/services/reservation/tag/tag.service'
import { useQuery } from 'react-query'

const ShowTags = ({ work_unit_id, renderOption, tags_relation }) => {
  const translate = useTranslate()
  const tags = useQuery('get-tag-by-work-unit-id', () =>
    tagServices.getTagsByWorkUnit(work_unit_id)
  )
  return (
    <EditInputsWrap label={translate('ra.title.tags')} required md={12} lg={12}>
      {tags.isLoading ? (
        <Skeleton variant='rectangular' width={'100%'} height={40} />
      ) : (
        <AutocompleteInput
          source='tags'
          options={tags.data?.filter((option) => !tags_relation?.some((rec) => rec.id === option.id))}
          validate={[required()]}
          optionsText={['long_name']}
          multiple
          renderOption={renderOption}
          renderTags
        />
      )}
    </EditInputsWrap>
  )
}

export const TagsModal = ({
  open,
  handleClose,
  titleModal,
  onSubmit,
  onSubmitSelect,
  loadingButtonCreateTagModal,
  loadingButtonSelectTagModal,
  work_unit_id,
  tags_relation,
}) => {
  const translate = useTranslate()
  const { cardId } = useCardId()

  // const postSave = (data) => {
  //   onSubmit && onSubmit(data, cardId)
  // }

  const postSaveSelect = (data) => {
    onSubmitSelect && onSubmitSelect(data, cardId)
  }

  const getText = (item, optionsText) => (optionsText ? optionsText.map((option) => item[option]) : item.name)

  const renderOption = (props, option, state) => (
    <li {...props}>
      <Chip
        variant='outlined'
        label={getText(option, ['long_name'])}
        avatar={option?.symbol && <Avatar>{option?.symbol}</Avatar>}
        style={{ backgroundColor: option?.color, cursor: 'pointer' }}
        size='small'
      />
    </li>
  )

  // const renderTags = (value, getTagProps) => {
  //   return value.map((option, index) => (
  //     <Chip
  //       variant='outlined'
  //       label={getText(option)}
  //       {...getTagProps({ index })}
  //       avatar={option?.symbol && <Avatar>{option?.symbol}</Avatar>}
  //       style={{ backgroundColor: option?.color }}
  //     />
  //   ))
  // }

  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Paper
          style={{
            padding: '10px',
            margin: '10px 0 30px 0',
          }}
        >
          <Typography variant='h5' component='h2' marginBottom={'30px'}>
            {translate('ra.title.select_exist_label')}
          </Typography>
          <Form id='post_select_form_tag' warnWhenUnsavedChanges onSubmit={postSaveSelect}>
            <Grid container spacing={3}>
              {open && (
                <ShowTags
                  work_unit_id={work_unit_id}
                  renderOption={renderOption}
                  tags_relation={tags_relation}
                />
              )}
            </Grid>
          </Form>
          <LoadingButton
            loading={loadingButtonSelectTagModal}
            variant='contained'
            startIcon={<SaveIcon />}
            form='post_select_form_tag'
            type='submit'
            style={{ marginTop: '10px' }}
          >
            {translate('ra.action.save')}
          </LoadingButton>
        </Paper>
        {/* <HasPermission permission={'hasEdit'} resource={'tag'}>
          <Paper
            style={{
              padding: '10px',
              margin: '10px 0 10px 0',
            }}
          >
            <Typography variant='h5' component='h2' marginBottom={'30px'}>
              Crear un Tag
            </Typography>
            <Form id='post_create_form_tag' warnWhenUnsavedChanges onSubmit={postSave}>
              <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.short_name')} required>
                  <TextInput source='tag.short_name' label='' fullWidth validate={[required()]} />
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.long_name')} required>
                  <TextInput source='tag.long_name' label='' fullWidth validate={[required()]} />
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.symbol')}>
                  <TextInput source='tag.symbol' label='' fullWidth />
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.color')}>
                  <ColorPIckerInput source='tag.color' fullWidth validate={[required()]} />
                </EditInputsWrap>

                <FormDataConsumer>
                  {({ formData }) => {
                    if (formData?.tag) {
                      const { tag } = formData
                      return (
                        <EditInputsWrap label={translate('ra.field.sample')}>
                          <Chip
                            size='small'
                            label={tag.long_name}
                            style={{ backgroundColor: tag.color }}
                            avatar={<Avatar>{tag.symbol}</Avatar>}
                          />
                        </EditInputsWrap>
                      )
                    }
                  }}
                </FormDataConsumer>
              </Grid>
            </Form>
            <LoadingButton
              loading={loadingButtonCreateTagModal}
              variant='contained'
              startIcon={<SaveIcon />}
              form='post_create_form_tag'
              type='submit'
              style={{ marginTop: '10px' }}
            >
              {translate('ra.action.save')}
            </LoadingButton>
          </Paper>
        </HasPermission> */}
        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <Button disabled></Button>
          <Button onClick={handleClose} variant='outlined' color='error'>
            {translate('ra.action.close')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
